<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <slot />
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {use3rdParties} from '#imports';

    use3rdParties();
</script>
